// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"067a0e60","354":"b1a69bc6","418":"d6b6c026"}[chunkId] + ".js";
};